import Widget from '@/plugins/dashboard/widgets/Estimated/Widget'
import Configure from '@/plugins/dashboard/widgets/Estimated/Configure'
import Chart from '@/plugins/dashboard/classes/Chart'

export default class extends Chart {
  static name = 'Estimated'
  static widget = Widget
  static configure = Configure
}
